import { IMemberConfigurationDataType, IMemberConfiguration } from '../../configuration/member_configuration';
import { IMemberDatasource, MemberDatasource } from '../../../global/datasources/member_datasource';

export class ApplicationFooterController {
  public models: {
    configuration: IMemberConfigurationDataType;
    data: IMemberDatasource;
  };

  public privacyPolicyUrl: string;
  public type: string;

  constructor(
    private $state: ng.ui.IStateService,
    $scope: any,
    ngMemberConfiguration: IMemberConfiguration,
    ngMemberDatasource: MemberDatasource
  ) {
    this.models = {
      configuration: ngMemberConfiguration.read(),
      data: ngMemberDatasource.read()
    };

    this.privacyPolicyUrl = ngMemberDatasource.read().core_config.privacy_policy_url;
    this.type = $scope.type;
  }

  isLanding(): boolean {
    return this.$state.includes('landing');
  }
}

angular
  .module('capability-ng-global')
  .controller('ngApplicationFooterController', ApplicationFooterController)
  .directive('applicationFooter', function(): ng.IDirective {
    return {
      restrict: 'E',
      templateUrl: 'lib/global/components/application_footer/application_footer.html',
      controller: 'ngApplicationFooterController',
      controllerAs: '$ctrl',
      scope: {
        type: '@'
      }
    };
  });



// WEBPACK FOOTER //
// ./app/lib/global/components/application_footer/application_footer.ts